import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

export default function LandingPage() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-6 font-inter">
      <div className="flex flex-col items-center gap-4 text-center max-w-md">
        <div className="flex items-center justify-center size-12 rounded-full bg-muted">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className="size-6 text-muted-foreground"
          />
        </div>
        <h1 className="text-2xl font-semibold text-foreground">
          This page cannot be accessed directly
        </h1>
        <p className="text-sm text-muted-foreground">
          Please return to the service that sent you here and try again.
        </p>
      </div>
    </div>
  );
}
